type FontSize = string | number;

type MeasurementUnit =
	| "em"
	| "rem"
	| "px"
	| "pt"
	| "cm"
	| "mm"
	| "in"
	| "pc"
	| "ex"
	| "ch"
	| "vw"
	| "vh"
	| "vmin"
	| "vmax";

const availableMeasurementUnits: Array<MeasurementUnit> = [
	"em",
	"rem",
	"px",
	"pt",
	"cm",
	"mm",
	"in",
	"pc",
	"ex",
	"ch",
	"vw",
	"vh",
	"vmin",
	"vmax",
];

const defaultScaleFactor: number = 1.5;

const calculateLineHeight: (fontSize: FontSize, scaleFactor?: number) => string = (
	fontSize: FontSize,
	scaleFactor: number = defaultScaleFactor,
) => {
	let calculatedLineHeight: string = "1.5rem";
	if (typeof fontSize !== "string" && typeof fontSize !== "number") {
		return calculatedLineHeight;
	} else if (typeof fontSize === "number") {
		calculatedLineHeight = fontSize * scaleFactor + "rem";
	} else {
		let fontSizeValue: number = 1;
		let fontSizeUnit: MeasurementUnit = "rem";
		for (let i = 0; i < availableMeasurementUnits.length; i++) {
			if (fontSize.includes(availableMeasurementUnits[i])) {
				fontSizeUnit = availableMeasurementUnits[i];
				fontSizeValue = parseFloat(fontSize.replace(availableMeasurementUnits[i], ""));
				break;
			}
		}
		calculatedLineHeight = fontSizeValue * scaleFactor + fontSizeUnit;
	}
	return calculatedLineHeight;
};

export default calculateLineHeight;
